exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swiper_c {\n  position: relative !important;\n  width: 100% !important;\n}\n.swiper_c .swiper-wrapper {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: end !important;\n      -ms-flex-align: end !important;\n          align-items: flex-end !important;\n}\n.swiper_c .swiper-wrapper .swiper-slide {\n  width: 100% !important;\n}\n", ""]);

// exports
